import React from 'react';
import { Box, Typography, alpha, useTheme } from '@mui/material';

const DueDateLane = ({ columns = [], dueByDate = {}, onDueClick, stickyLeftWidth }) => {
	const theme = useTheme();

	return (
		<>
			<Box
				sx={{
					position: 'sticky',
					left: 0,
					zIndex: 3,
					backgroundColor: theme.palette.background.paper,
					borderBottom: '1px solid',
					borderRight: '1px solid',
					borderColor: 'divider',
					px: 1.5,
					py: 1,
					display: 'flex',
					alignItems: 'center',
					minWidth: stickyLeftWidth,
					width: stickyLeftWidth,
				}}
			>
				<Typography variant="caption" fontWeight={700} color="text.secondary">
					Due
				</Typography>
			</Box>
			{columns.map((col) => {
				const items = dueByDate[col.date] || [];
				return (
					<Box
						key={`due-${col.date}`}
						sx={{
							borderBottom: '1px solid',
							borderRight: '1px solid',
							borderColor: 'divider',
							p: 0.75,
							minHeight: 56,
							backgroundColor: alpha(theme.palette.warning.main, 0.04),
						}}
					>
						{items.map((item) => (
							<Box
								key={item.job_id}
								component="button"
								type="button"
								onClick={() => onDueClick?.(item)}
								sx={{
									display: 'block',
									width: '100%',
									textAlign: 'left',
									border: '1px solid',
									borderColor: alpha(theme.palette.warning.main, 0.35),
									backgroundColor: alpha(theme.palette.warning.main, 0.12),
									borderRadius: 1.5,
									px: 1,
									py: 0.5,
									mb: 0.5,
									cursor: onDueClick ? 'pointer' : 'default',
									'&:hover': onDueClick
										? {
												backgroundColor: alpha(
													theme.palette.warning.main,
													0.2,
												),
											}
										: undefined,
								}}
							>
								<Typography
									variant="caption"
									sx={{
										fontWeight: 700,
										display: 'block',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
									}}
								>
									Due - {item.job_name}
								</Typography>
								{item.customer_name ? (
									<Typography
										variant="caption"
										color="text.secondary"
										sx={{
											display: 'block',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
											whiteSpace: 'nowrap',
										}}
									>
										{item.customer_name}
									</Typography>
								) : null}
							</Box>
						))}
					</Box>
				);
			})}
		</>
	);
};

export default DueDateLane;
